import { supplyService } from '@/services/supplyService';
import { invalidateSupplyTableCache } from '@/utils/supplyTableCache';

/**
 * Invalida caché cliente de supply-table y opcionalmente precalienta KPIs en servidor
 * tras publicar demanda y recalcular cantidades sugeridas (DP-PUB-001 / D5).
 */
export async function refreshSupplyAfterDemandPublish(
  warehouseId: number | null,
): Promise<void> {
  if (warehouseId == null || !Number.isFinite(warehouseId)) {
    return;
  }

  invalidateSupplyTableCache(warehouseId);

  try {
    await supplyService.getSupplyTableData({
      warehouse_id: warehouseId,
      force_refresh: true,
      metrics_only: true,
      needs_reorder: false,
      suggested_greater_zero: false,
    });
  } catch (error) {
    console.warn('[demand-publish] Supply prefetch after publish failed:', error);
  }
}
